import React from 'react';
import { withRouter } from 'react-router-dom';
import {getBundleById,replaceBundle} from 'actions/bundle';
import BundleEdit from 'components/BundleEdit';
import BaseModal from 'components/BaseModal';
class BundleEditPage extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            info:null,
            loading:true
        };
        this.id = props.match.params.id;
    }
    componentDidMount(){
        getBundleById(this.id).then(res=>{
            this.setState({info:res.data,loading:false});
        });
    }

    onSubmit = (params)=>{
        params.sdk_req_id = this.id;
        this.setState({loading:true});
        replaceBundle(this.id,params).then(res=>{
            BaseModal.success({
                title:'Success',
                onOk:()=>{
                    this.props.history.push('/pages/app/bundle');
                }
            });
        }).catch(()=>{
            this.setState({loading:false});
        });
    }

    render() {
        return(
            <BundleEdit
                loading={this.state.loading}
                onSubmit={this.onSubmit}
                defaultInfo={this.state.info}
                isEdit
            />
        );
    }
}

export default withRouter(BundleEditPage);



// WEBPACK FOOTER //
// ./src/pages/BundleEdit/index.js